var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderAffiliateSass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0786 9.39635C13.9543 9.04688 13.725 8.74435 13.422 8.53017C13.119 8.31599 12.7573 8.20063 12.3862 8.19987H10.9968C10.6005 8.1978 10.2174 8.34271 9.92173 8.60657C9.62605 8.87044 9.43877 9.23452 9.39609 9.62841C9.35341 10.0223 9.45836 10.418 9.69067 10.739C9.92297 11.0601 10.2661 11.2836 10.6537 11.3664L12.7693 11.8278C13.2019 11.9224 13.5842 12.1735 13.8428 12.5328C14.1014 12.8921 14.2181 13.3343 14.1704 13.7743C14.1227 14.2143 13.914 14.6213 13.5844 14.9168C13.2547 15.2124 12.8275 15.3758 12.3846 15.3757H11.1892C10.4076 15.3757 9.74288 14.8774 9.49671 14.1807M11.7877 8.19987V6.40516M11.7877 17.1704V15.3772M4.30395 21.9932V18.1485H8.15044M21.8285 10.1607C22.237 12.3371 21.9109 14.5875 20.9014 16.5587C19.8919 18.5298 18.2562 20.1101 16.251 21.0516C14.2457 21.993 11.9845 22.2423 9.82222 21.7603C7.65992 21.2783 5.71895 20.0923 4.30395 18.3884M2.17146 13.8393C1.763 11.6629 2.08911 9.41247 3.0986 7.44132C4.10809 5.47017 5.74382 3.88985 7.74904 2.94841C9.75427 2.00696 12.0155 1.75769 14.1778 2.2397C16.3401 2.72171 18.281 3.90773 19.696 5.61161M19.696 2.00679V5.85152H15.8496",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderAffiliateSass);
export default __webpack_public_path__ + "static/media/header-affiliate-sass.013bfa9f11c6ad3eb6d93f41906d5df4.svg";
export { ForwardRef as ReactComponent };